const SIZE = { md: 'text-[26px] leading-8', lg: 'text-4xl' };

export default function Metric({ label, value, sub, size = 'md', valueClassName = 'text-gray-900 dark:text-gray-100', subClassName = 'text-gray-500 dark:text-gray-400' }) {
  return (
    <div className="min-w-0">
      <div className="text-[11px] uppercase tracking-wider text-gray-500 dark:text-gray-400">{label}</div>
      <div className={`mt-0.5 font-mono font-light tracking-tight tabular-nums ${SIZE[size] || SIZE.md} ${valueClassName}`}>{value}</div>
      {sub != null && <div className={`text-xs ${subClassName}`}>{sub}</div>}
    </div>
  );
}
